import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Link, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import CollectionItem from '../../Collection/CollectionItem'
import {
  fetchShopCollection,
  fetchPromoCodes,
  selectPromoCodes,
} from '../../../reducers/Organisation/organisationShopReducer'

import OrganisationPromoCodesModal from './OrganisationPromoCodesModal'

const OrganisationPromoCodes = () => {
  const { t } = useTranslation(['organisation'])
  const dispatch = useDispatch()
  const params = useParams()
  const promoCodes = useSelector(selectPromoCodes)

  useEffect(() => {
    dispatch(fetchShopCollection())
    dispatch(fetchPromoCodes())
  }, [dispatch])

  return (
    <div className="ctp-shop-list">
      {promoCodes.map((code) => (
        <Link key={code.id} to={`/dashboard/organisation/promo-codes/${code.id}`}>
          <CollectionItem additionalClass="ctp-shop-item">
            <span>{code.hash}</span>
            <button className="button button-primary">
              {t('organisation:promoCodes.list.show')}
            </button>
          </CollectionItem>
        </Link>
      ))}
      <OrganisationPromoCodesModal params={params} />
    </div>
  )
}

export default OrganisationPromoCodes
